import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const questionRouter: RouteConfig = {
  path: '/questions',
  component: Layout,
  redirect: '/questions/question_list',
  name: '问卷管理',
  meta: {
    title: '问卷管理'
  },
  children: [
    {
      path: 'question_list',
      name: 'question_list',
      component: () => import(/* webpackChunkName: "questions" */'@/views/questions/question_list.vue'),
      meta: {
        title: '问卷列表'
      }
    },
    {
      path: 'questionTopic/edit/:id',
      name: 'questionTopicEdit',
      component: () => import(/* webpackChunkName: "questions" */'@/views/questions/questionTopic_list.vue'),
      meta: {
        title: '问卷内容编辑'
      }
    },
    {
      path: 'statistics/:id',
      name: 'question-statistics',
      component: () => import(/* webpackChunkName: "questions" */'@/views/questions/report.vue'),
      meta: {
        title: '问卷统计'
      }
    },
  ]
}

export default questionRouter
